import { render, staticRenderFns } from "./NotificationItemReferenceLog.vue?vue&type=template&id=b0a90988"
import script from "./NotificationItemReferenceLog.vue?vue&type=script&lang=js"
export * from "./NotificationItemReferenceLog.vue?vue&type=script&lang=js"
import style0 from "./NotificationItemReferenceLog.vue?vue&type=style&index=0&id=b0a90988&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports